import '../jquery-global.js';

function parseVideo(url) {
    // - Supported YouTube URL formats:
    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
    //   - http://youtu.be/My2FRPA3Gf8
    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
    // - Supported Vimeo URL formats:
    //   - http://vimeo.com/25451551
    //   - http://player.vimeo.com/video/25451551
    // - Also supports relative URLs:
    //   - //player.vimeo.com/video/25451551

    let site;

    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

    if (RegExp.$3.indexOf('youtu') > -1) {
        site = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
        site = 'vimeo';
    }

    return {
        type: site,
        id: RegExp.$6
    };
}

export function isVideoUrlValid(url) {
    const parsed = parseVideo(url);

    return typeof (parsed) !== 'undefined' && ["vimeo", "youtube"].includes(parsed.type);
}

export function createVideo(url, width, height) {
    // Returns an iframe of the video with the specified URL.
    const videoObj = parseVideo(url);
    let iframe = document.createElement('iframe');

    if (width) {
        iframe.setAttribute('width', width);
        iframe.setAttribute('height', height);
    }

    const protocol = window.location.protocol;

    iframe.setAttribute('frameborder', 0);

    if (videoObj.type === 'youtube') {
        iframe.setAttribute('src', protocol + '//www.youtube.com/embed/' + videoObj.id);
    } else if (videoObj.type === 'vimeo') {
        iframe.setAttribute('src', protocol + '//player.vimeo.com/video/' + videoObj.id);
    }

    return iframe;
}

export function getVideoThumbnail(url, cb) {
    // Obtains the video's thumbnail and passed it back to a callback function.
    const videoObj = parseVideo(url);

    if (videoObj.type == 'youtube') {
        cb('//img.youtube.com/vi/' + videoObj.id + '/maxresdefault.jpg');
    } else if (videoObj.type == 'vimeo') {
        // Requires jQuery
        jQuery.get('http://vimeo.com/api/v2/video/' + videoObj.id + '.json', function (data) {
            cb(data[0].thumbnail_large);
        });
    }
}

export default function validate_video_link(value) {
    return !!value && isVideoUrlValid(value);
};
